import { render, staticRenderFns } from "./WorkspacePopup.vue?vue&type=template&id=0325da0f&scoped=true&"
import script from "./WorkspacePopup.vue?vue&type=script&lang=ts&"
export * from "./WorkspacePopup.vue?vue&type=script&lang=ts&"
import style0 from "./WorkspacePopup.vue?vue&type=style&index=0&id=0325da0f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0325da0f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
